import Layout from "@/views/Layout.vue";
const files = require.context(".", true, /\.js$/);
const modules = [];
files.keys().forEach((key) => {
  if (key === "./index.js" || key === "./router.config.js") {
    return;
  }
  modules.push(files(key).default);
});
export const constantRouterMap = [
  {
    path: "/",
    redirect: "/home",
    component: Layout,
    children: [
      {
        path: "home", //首页
        name: "home",
        component: () => import("@/views/home/Index.vue"),
      },
    ],
  },
  ...modules,
];
